import React from "react";
import { connect } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { userActions } from "../_actions";
import "./login.css";
import { withTranslation } from "react-i18next";
import Modal from "@mui/material/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import { OtpInput } from "./OtpInput";
import { userService } from "../_services";
import { history } from "../_helpers";
import { flushSync } from "react-dom";

class ForgotPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      requestSubmitted: false,
      error: false,
      otp: "",
      resetPasswordFailureCount: 0
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    const { name, value } = e.target;
    flushSync(()=>{
      this.setState({ [name]: value });
    })
  }

  handleSubmit(e) {
    e.preventDefault();

   flushSync(()=>{ this.setState({ requestSubmitted: true });})
    const { email } = this.state;
    const { dispatch } = this.props;
    if (email) {
      dispatch(userActions.forgotPassword(email));
    }
  }

  handleOtpChange = (validOtp) => {
    flushSync(()=>{this.setState({ otp: validOtp });})
  }

  validateOtp = async () => {
    const { dispatch } = this.props;
    try {
      const res = await userService.validateResetPasswordOtp({ otp: this.state.otp?.toString() });
      history.push('/reset?AccessToken=' + res.token);
    } catch (error) {
      if (this.state.resetPasswordFailureCount > 1) {
        flushSync(()=>{
          this.setState({
          email: "",
          requestSubmitted: false,
          otp: "",
          resetPasswordFailureCount: 0
        });
        })
        dispatch(userActions.backToForgotPasswordEmail());
      } else {
        flushSync(()=>{
          this.setState({ otp:"", resetPasswordFailureCount: this.state.resetPasswordFailureCount + 1, error: true })
        })
      }
      console.log('Error validating OTP:', error);
    }
  };


  render() {
    const { emailSent, alert, t, noError } = this.props;
    const { email, requestSubmitted, resetPasswordFailureCount, otp } = this.state;
    const { webApiUrl } = window.appConfig;
    return (
      (<Grid
          container
          spacing={0}
          direction="column"
          className="login-grid"
          style={{
            height: "100vh",
            backgroundImage: "url(" + webApiUrl + "api/Config/WebBackground)",
            overflow: "auto"
          }}
          sx={{
            alignItems: "center",
            justifyContent: "center"
          }}>
        <CssBaseline />
        <Grid className="login-container">
          <Grid
            container
            spacing={0}
            direction="column"
            sx={{
              alignItems: "center",
              justifyContent: "center"
            }}>
            <img
              src={webApiUrl + "api/Config/WebLogo"}
              style={{ maxWidth: 200, maxHeight: 50 }}
              alt="JPDS"
            />
          </Grid>
          <Typography component="h1" variant="h5" align="center">
            {t("login.forgotpassword.text")}
          </Typography>

          {!noError && !emailSent && alert.message && (
            <Box className={`alert ${alert.type}`} sx={{
              my: 1
            }}>
              {t(alert.message)}
            </Box>
          )}
          {!emailSent && (
            <form noValidate onSubmit={this.handleSubmit}>
              <TextField
                error={requestSubmitted && !email}
                required
                variant="standard"
                margin="normal"
                fullWidth
                id="email"
                label={t("general.email.label")}
                name="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={this.handleChange}
                disabled={noError}
              />
              <Grid container sx={{
                alignItems: "center"
              }}>
                <Grid
                  align="right"
                  size={{
                    sm: 12
                  }}>
                  <Link component={RouterLink} to="/login" variant="body1">
                    {t("general.back")}
                  </Link>
                </Grid>
              </Grid>
              <Grid align="center" size={{xs:12}}>
                <Box sx={{
                  mt: 2
                }}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={noError}
                  >
                    {t("general.send")}
                  </Button>
                </Box>
              </Grid>
            </form>
          )}

          {emailSent && (
            <React.Fragment>
              <Grid align="center" size={{xs:12}}>
                <Box sx={{
                  mt: 2
                }}>
                  <label>{t("reset.email.success")}</label>
                </Box>
              </Grid>
              <Grid align="center" size={{xs:12}}>
                <Box
                  sx={{
                    mt: 2,
                    display: "flex",
                    justifyContent: "center"
                  }}>
                  <OtpInput resetPasswordFailureCount={resetPasswordFailureCount} otp={otp} handleOtpChange={this.handleOtpChange} />
                </Box>
              </Grid>
              <Grid align="center" size={{xs:12}}>
                <Box sx={{
                  mt: 2
                }}>
                  <Button
                    type="submit"
                    variant="outlined"
                    color="primary"
                    disabled={this.state.otp?.length !== 6}
                    onClick={this.validateOtp}
                  >
                    {t("general.proceed")}
                  </Button>
                </Box>
              </Grid>
            </React.Fragment>
          )}

          {
            <Modal open={noError === true}>
              <Grid
                container
                direction="column"
                style={{ minHeight: "100vh" }}
                sx={{
                  alignItems: "center",
                  justifyContent: "center"
                }}>
                <Grid>
                  <CircularProgress />
                </Grid>
              </Grid>
            </Modal>
          }
        </Grid>
      </Grid>)
    );
  }
}

function mapStateToProps(state) {
  const { emailSent, noError } = state.authentication;
  const { alert } = state;
  return {
    emailSent,
    alert,
    noError,
  };
}

const connectedForgotPage = connect(mapStateToProps)(
  withTranslation()(ForgotPage)
);
export { connectedForgotPage as ForgotPage };
